<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="会员名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.member_name }}
        </template>
      </el-table-column>

      <el-table-column label="价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>

      <el-table-column label="红包限额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.discount_limit }}
        </template>
      </el-table-column>

      <el-table-column label="快递代取次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pickup_count === -1 ? "无限次" : scope.row.pickup_count }}
        </template>
      </el-table-column>

      <el-table-column label="按月上楼" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_upstairs === 1" type="success">是</el-tag>
          <el-tag v-else-if="scope.row.is_upstairs === 0" type="danger">否</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_on === 0" type="danger">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="会员名称" prop="member_name">
          <el-input v-model="form.member_name"></el-input>
        </el-form-item>

        <el-form-item label="价格/月" prop="price">
          <el-input-number size="small" v-model="form.price" :min="0" :precision="2" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="红包限额/元" prop="discount_limit">
          <el-input-number size="small" v-model="form.discount_limit" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="快递代取次数" prop="pickup_count">
          <el-input-number size="small" v-model="form.pickup_count" :min="-1" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="按月上楼" prop="is_upstairs">
          <el-switch v-model="form.is_upstairs" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number size="small" v-model="form.weight" :min="1" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*权重越小，排名越前</div>
          </div>
        </el-form-item>

        <el-form-item label="状态" prop="is_on">
          <el-switch v-model="form.is_on" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>

        <el-form-item label="权益说明" prop="describe">
          <tinymce ref="tinymce" :height="400" v-model="form.describe" :value="form.describe" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import Tinymce from "@/components/Tinymce";

  export default {
    components: { Tinymce },
    data() {
      return {
        list: null,
        listLoading: true,
        listQuery: {
          school_id: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          member_name: "",
          price: 0,
          discount_limit: 0,
          pickup_count: 0,
          is_upstairs: 0,
          weight: 1,
          describe: "",
          is_on: 1,
        },
        rules: {
          member_name: [{ required: true, message: "会员名称不能为空", trigger: "change" }],
          price: [{ required: true, message: "价格不能为空", trigger: "change" }],
          discount_limit: [{ required: true, message: "红包限额不能为空", trigger: "change" }],
          pickup_count: [{ required: true, message: "快递代取次数不能为空", trigger: "change" }],
          is_upstairs: [{ required: true, message: "按月上楼不能为空", trigger: "change" }],
          weight: [{ required: true, message: "权重不能为空", trigger: "change" }],
          describe: [{ required: true, message: "权益说明不能为空", trigger: "change" }],
          is_on: [{ required: true, message: "状态不能为空", trigger: "change" }],
        },
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/pickupMember/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data;
          this.listLoading = false;
        });
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          member_name: "",
          price: 0,
          discount_limit: 0,
          pickup_count: 0,
          is_upstairs: 0,
          weight: 1,
          describe: "",
          is_on: 1,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        if(this.$refs.tinymce) this.$refs.tinymce.setContent("")
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        if(this.$refs.tinymce) this.$refs.tinymce.setContent(row.describe||"")
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/pickupMember/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
